import React from 'react';
import { Link } from 'react-router-dom';

const freeFeatures = [
  {
    icon: '/icons/image-IeKGYKeLd25OWlrmd5WrSsfbD7OIPA.webp',
    title: 'Cost Tracker',
    description: 'Track every dollar with real-time budget monitoring',
    alt: 'BuildPilot App Cost Tracker feature icon - track building costs and budget in Australia',
    href: '/tools/cost-tracker'
  },
  {
    icon: '/icons/image-c5KNZklDsVHok6rJk9KE8P5sANBOpM.webp',
    title: 'Milestones',
    description: 'Track major stages with visual progress indicators',
    alt: 'BuildPilot App Milestones feature icon - monitor building project progress',
    href: '/tools/milestones'
  },
  {
    icon: '/icons/image-HiChF8iNxEQpjV9vKH44UoEduGznyr.webp',
    title: 'Checklists',
    description: 'Stage-specific checklists so nothing falls through the cracks',
    alt: 'BuildPilot App Checklists feature icon - stay organised with building task lists',
    href: '/tools/checklists'
  },
  {
    icon: '/icons/image-fBcRbels1vyrggdKApkjSbKHSxwMgd.webp',
    title: 'Government Resources',
    description: 'Grants, permits, and regulations in one place',
    alt: 'BuildPilot App Government Resources icon - access official Australian building information',
    href: '/tools/government-resources'
  },
  {
    icon: '/icons/image-X4EofF15e7UUioIAr6nUli2CROWWLy.webp',
    title: 'Find a Business',
    description: 'Discover builders and trades near you',
    alt: 'BuildPilot App Find a Business feature icon - search local builders and tradespeople',
    href: '/tools/find-business'
  },
  {
    icon: '/icons/image-Q2AyLFpsfle7dsgOfa3VRInvXpfrjJ.webp',
    title: 'Documents',
    description: 'Secure storage for contracts, plans, and permits',
    alt: 'BuildPilot App Documents feature icon - store and manage building project files',
    href: '/tools/documents'
  },
  {
    icon: '/icons/image-L5zctAjYpsgWJCCiLRhRHOitYnxfv6.webp',
    title: 'Builder Licence Check',
    description: 'Instantly verify any builder\'s licence is current',
    alt: 'BuildPilot App Builder Licence Check icon - verify Australian builder credentials and licences',
    href: '/tools/licence-check'
  },
  {
    icon: '/icons/image-x3jWH9IOEgOOgjk99NJoK1WgftvOP3.webp',
    title: 'Building Insurance Check',
    description: 'Verify insurance and warranties for your project',
    alt: 'BuildPilot App Building Insurance Check icon - verify builder insurance validity',
    href: '/tools/insurance-check'
  },
  {
    icon: '/icons/image-kj305LnLaUTHEFgXM33ZRAyVR6wbvs.webp',
    title: 'Solar Orientation Guide',
    description: 'Position your home for optimal energy efficiency',
    alt: 'BuildPilot App Solar Orientation Guide icon - optimise home solar positioning in Australia',
    href: '/tools/solar-orientation'
  },
  {
    icon: '/icons/house-and-land.webp',
    title: 'House & Land Search',
    description: 'Browse thousands of house and land packages Australia-wide',
    alt: 'BuildPilot App House and Land Search - browse packages from builders across Australia',
    href: '/tools'
  },
  {
    icon: '/icons/new-home-designs.webp',
    title: 'New Home Designs',
    description: 'Explore hundreds of floor plans from verified builders',
    alt: 'BuildPilot App New Home Designs - explore floor plans filtered to your state',
    href: '/tools'
  },
  {
    icon: '/icons/find-a-tradie.webp',
    title: 'Find a Tradie',
    description: 'Connect with verified tradies with licence and insurance checks',
    alt: 'BuildPilot App Find a Tradie - connect with verified electricians, plumbers and more',
    href: '/tools'
  },
  {
    icon: '/icons/find-a-supplier.webp',
    title: 'Find a Supplier',
    description: 'Discover suppliers for tiles, kitchens, bathrooms, and more',
    alt: 'BuildPilot App Find a Supplier - compare products and request quotes',
    href: '/tools'
  },
];

const fullThrottleFeatures = [
  {
    icon: '/icons/4256c6ea2feae41026c28ad522fa46ef383d2f986495975d760fe8160f5d4921.webp',
    title: 'Defects Scanner',
    description: 'Photo defects and get instant severity ratings',
    alt: 'BuildPilot App Defects Scanner premium feature icon - photograph and identify building defects',
    href: '/tools/defects-scanner'
  },
  {
    icon: '/icons/image-X4EofF15e7UUioIAr6nUli2CROWWLy.webp',
    title: 'Find a Builder',
    description: 'AI-matched builders perfect for YOUR project',
    alt: 'BuildPilot App Find a Builder premium feature icon - AI-powered builder matching for your project',
    href: '/tools/builder-match'
  },
  {
    icon: '/icons/image-dAl3njirA4NBVpbQvBuAG6YLwKu9eE.webp',
    title: 'Quote Comparison',
    description: 'AI analysis of quotes to spot hidden costs and red flags',
    alt: 'BuildPilot App Quote Comparison premium feature icon - compare builder quotes and inclusions',
    href: '/tools/quote-comparison'
  },
  {
    icon: '/icons/6AA8E368-E547-46DC-BA51-EB15A456A3EE.webp',
    title: 'Facade Visualiser',
    description: 'See your home transformed with different materials and styles',
    alt: 'BuildPilot App Facade Visualiser premium feature icon - visualise your home design',
    href: '/tools/facade-visualiser'
  },
  {
    icon: '/icons/3d-interior.webp',
    title: '3D Interior',
    description: 'See any room rendered in different interior styles',
    alt: 'BuildPilot App 3D Interior premium feature - visualise rooms in different styles',
    href: '/tools'
  },
  {
    icon: '/icons/furniture-planner.webp',
    title: 'Furniture Planner',
    description: 'Intelligent furniture placement and traffic flow analysis',
    alt: 'BuildPilot App Furniture Planner premium feature - optimal furniture layout suggestions',
    href: '/tools'
  },
  {
    icon: '/icons/email-forwarding.webp',
    title: 'Email Forwarding & Intelligence',
    description: 'Forward builder emails for plain-language summaries and action items',
    alt: 'BuildPilot App Email Intelligence premium feature - AI-powered email analysis',
    href: '/tools'
  },
  {
    icon: '/icons/project-health.webp',
    title: 'Project Health',
    description: 'Overall health score monitoring budget, timeline, and risk',
    alt: 'BuildPilot App Project Health premium feature icon - analyse building project cost and progress',
    href: '/tools/project-health'
  },
  {
    icon: '/icons/bp-intelligence.webp',
    title: 'BuildPilot Intelligence Adviser',
    description: '24/7 building expert tailored to your project',
    alt: 'BuildPilot App Intelligence Adviser premium feature icon - AI-powered building advice and monitoring',
    href: '/tools/buildpilot-intelligence'
  }
];

const FeatureSection = () => {
  return (
    <section id="features" className="py-24 bg-neutral-50" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl sm:text-5xl text-gray-900 mb-4">
            Tools for <span className="gradient-text">every</span> stage.
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            From planning to completion, BuildPilot App has you covered.
          </p>
        </div>

        {/* Free Features */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-8">
            <span className="px-4 py-1.5 bg-emerald-100 text-emerald-700 text-sm font-semibold rounded-full">
              Free
            </span>
            <h3 className="text-2xl font-semibold text-gray-900">Core Planning Tools</h3>
          </div>
          <p className="text-gray-500 mb-6">Track costs, find builders and tradies, manage documents, verify licences, and more.</p>
          
          {/* Mobile: Compact horizontal list */}
          <div className="sm:hidden space-y-2">
            {freeFeatures.map((feature, index) => (
              <Link 
                to={feature.href}
                key={index} 
                className="bg-white rounded-xl px-4 py-3 flex items-center gap-3 border border-gray-100 hover:border-purple-300 hover:shadow-md transition-all"
                data-testid={`free-feature-mobile-${index}`}
              >
                <img 
                  src={feature.icon} 
                  alt={feature.alt}
                  className="w-10 h-10 object-contain flex-shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <h4 className="font-semibold text-gray-900 text-sm">{feature.title}</h4>
                  <p className="text-xs text-gray-500 truncate">{feature.description}</p>
                </div>
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            ))}
          </div>

          {/* Tablet/Desktop: Grid layout */}
          <div className="hidden sm:grid sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {freeFeatures.map((feature, index) => (
              <Link 
                to={feature.href}
                key={index} 
                className="bg-white rounded-2xl p-5 hover:shadow-lg transition-all hover:-translate-y-1 border border-gray-100 hover:border-purple-300"
                data-testid={`free-feature-${index}`}
              >
                <img 
                  src={feature.icon} 
                  alt={feature.alt}
                  className="w-14 h-14 object-contain mb-3"
                />
                <h4 className="font-semibold text-gray-900 mb-1 text-sm">{feature.title}</h4>
                <p className="text-xs text-gray-500">{feature.description}</p>
              </Link>
            ))}
          </div>
        </div>

        {/* Full Throttle Features */}
        <div>
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <span className="px-4 py-1.5 text-sm font-semibold rounded-full text-white animated-gradient-header">
              Full Throttle
            </span>
            <h3 className="text-2xl font-semibold text-gray-900">Premium Features</h3>
          </div>
          <p className="text-gray-500 mb-6">Unlock powerful tools for smarter decisions and complete project control.</p>
          
          {/* Mobile: Compact horizontal list */}
          <div className="sm:hidden space-y-2">
            {/* Includes Free Tools - Mobile */}
            <Link 
              to="/tools"
              className="bg-gradient-to-r from-emerald-50 to-emerald-100 rounded-xl px-4 py-3 flex items-center gap-3 border border-emerald-200 hover:shadow-md transition-all"
              data-testid="includes-free-tile-mobile"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div className="min-w-0 flex-1">
                <h4 className="font-semibold text-emerald-700 text-sm">Includes all Free tools</h4>
                <p className="text-xs text-emerald-600">All core planning tools included</p>
              </div>
            </Link>

            {fullThrottleFeatures.map((feature, index) => (
              <Link 
                to={feature.href}
                key={index} 
                className="bg-white rounded-xl px-4 py-3 flex items-center gap-3 border border-gray-100 hover:border-purple-300 hover:shadow-md transition-all"
                data-testid={`premium-feature-mobile-${index}`}
              >
                <img 
                  src={feature.icon} 
                  alt={feature.alt}
                  className="w-10 h-10 object-contain flex-shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <h4 className="font-semibold text-gray-900 text-sm">{feature.title}</h4>
                  <p className="text-xs text-gray-500 truncate">{feature.description}</p>
                </div>
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            ))}
          </div>

          {/* Tablet/Desktop: Grid layout */}
          <div className="hidden sm:grid sm:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-fr">
            {/* Includes Free Tools Tile */}
            <Link 
              to="/tools"
              className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl p-5 border border-emerald-200 flex flex-col justify-center hover:shadow-lg transition-all"
              data-testid="includes-free-tile"
            >
              <div className="flex items-center gap-2 mb-2">
                <svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-emerald-700 font-semibold text-sm">Includes all Free tools</span>
              </div>
              <p className="text-xs text-emerald-600">All core planning tools included</p>
            </Link>

            {fullThrottleFeatures.map((feature, index) => (
              <Link 
                to={feature.href}
                key={index} 
                className="relative group"
                data-testid={`premium-feature-${index}`}
              >
                {/* Static gradient glow behind the tile */}
                <div 
                  className="absolute -inset-0.5 rounded-2xl opacity-0 group-hover:opacity-50 transition-opacity duration-300"
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
                    filter: 'blur(8px)'
                  }}
                />
                
                {/* White tile */}
                <div className="relative bg-white rounded-2xl p-5 border border-gray-100 transition-shadow duration-300 group-hover:shadow-lg h-full">
                  <img 
                    src={feature.icon} 
                    alt={feature.alt}
                    className="w-14 h-14 object-contain mb-3"
                  />
                  <h4 className="font-semibold text-gray-900 mb-1 text-sm leading-tight">{feature.title}</h4>
                  <p className="text-xs text-gray-500 line-clamp-2">{feature.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
